import _ from 'lodash';
import classNames from 'classnames';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { Shooting } from 'models';
import { GRID_PAGE_SIZE } from 'config/constants';
import ShootingListItem from './ShootingListItem';

const useStyles = makeStyles({
  shootingGroup: {
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, .05)',
    padding: '30px',
  },
  shootingList: {
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  shootingItem: {
    '&:first-child': {
      marginTop: 0,
    },

    '@media (min-width: 1024px)': {
      width: 'calc(100% / 3 - 10px)',
      marginTop: 15,
      marginRight: 15,

      '&:nth-child(2), &:nth-child(3)': {
        marginTop: 0,
      },

      '&:nth-child(3n)': {
        marginRight: 0,
      },
    },

    '@media (min-width: 768px) and (max-width: 1023px)': {
      width: 'calc(50% - 5px)',
      marginTop: 10,
      marginRight: 10,

      '&:nth-child(2)': {
        marginTop: 0,
      },

      '&:nth-child(2n)': {
        marginRight: 0,
      },
    },

    '@media (max-width: 767px)': {
      width: '100%',
      marginTop: 10,
    },
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
});

interface Props {
  className: string;
  shootings: Shooting[];
}

function ShootingsGroup({ className, shootings }: Props) {
  const styles = useStyles();

  const [page, updatePage] = useState(1);

  const onPageChange = (_: object, page: number) => {
    updatePage(page);
  };

  const pageCount = _.ceil(shootings.length / GRID_PAGE_SIZE);
  const displayShootings = shootings.slice((page - 1) * GRID_PAGE_SIZE, page * GRID_PAGE_SIZE);

  return (
    <Box className={classNames(className, styles.shootingGroup)}>
      <Box className={styles.shootingList}>
        {displayShootings.map((m: Shooting) => {
          return <ShootingListItem key={m.id} shooting={m} className={styles.shootingItem} />;
        })}
      </Box>

      {shootings.length && pageCount > 1 ? (
        <Pagination
          className={styles.pagination}
          count={pageCount}
          page={page}
          color='primary'
          onChange={onPageChange}
        />
      ) : null}
    </Box>
  );
}

ShootingsGroup.defaultProps = {
  className: null,
  shootings: [],
};

ShootingsGroup.propTypes = {
  className: PropTypes.string,
  shootings: PropTypes.array,
};

export default ShootingsGroup;
